// Poll interval resolution. Runtime env (window._env_ / build env) is the source of truth;
// these named constants are only the last-resort fallbacks when it is missing or unusable.
export const DEFAULT_POLL_MS = 3000;
export const DEFAULT_MIN_POLL_MS = 500;

const positiveNumber = (raw) => {
  const n = Number(raw);
  return raw !== "" && raw !== null && raw !== undefined && Number.isFinite(n) && n > 0 ? n : null;
};

/** The poll interval in ms: `rawMs` if it is a finite number >= the minimum, else the default
 * (never below the minimum). A negative, zero, non-numeric or too-small value can therefore
 * never turn polling into a request storm. */
export function resolvePollMs(rawMs, rawMinMs, defaultMs = DEFAULT_POLL_MS, defaultMinMs = DEFAULT_MIN_POLL_MS) {
  const min = positiveNumber(rawMinMs) ?? defaultMinMs;
  const value = positiveNumber(rawMs);
  return value !== null && value >= min ? value : Math.max(defaultMs, min);
}
